/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.16",
    versionName: "0.2.0-nightly.2025.11.16",
    versionChannel: "nightly",
    buildDate: "2025-11-16T00:08:40.110Z",
    commitHash: "534ee1d2825fb69b69227f71257855f03b84163a",
};
